import { h } from "preact";

import style from "./style";
import { Text } from "preact-i18n";

/**
 * Ordered content list used for book detail page
 * Each entry should link to the corresponding part of the page
 * @param {Array<{text: string; link: string;}>} List of content links
 */
const ContentList = ({
  items = [
    {
      text: "",
      link: ""
    }
  ]
}) => (
  <section class={style["content"]}>
    <ol>
      {items
        .map((item, index) => (
          <li key={index}>
            <a href={item.link}><Text id={`headings.${item.text}`}>
              {item.text}
            </Text></a>
          </li>
        ))}
    </ol>
  </section>
);

export default ContentList;
